import * as React from "react";
import { Button, Input, InputRef, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Leaves } from "../../../libs/types";
import {handleReset} from "./index";

export const getColumnSearchProps = <Entity,>(
  dataIndex:  Leaves<Entity>,
  setSearchText: React.Dispatch<React.SetStateAction<{ [p: string]: string }>>,
  searchText: { [p: string]: string },
  searchInput: React.RefObject<InputRef>,
): {
  filterDropdown: ({
                     setSelectedKeys,
                     selectedKeys,
                     clearFilters,
                     close,
                   }: {
    setSelectedKeys: any
    selectedKeys: any
    clearFilters?: any
    close: any
  }) => JSX.Element
  filterIcon: (filtered: boolean) => JSX.Element
  onFilter: (value: any, record: any) => boolean
  render: (text: any) => any
  onFilterDropdownOpenChange: (visible: any) => void
} => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, clearFilters, close }) => (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        ref={searchInput}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() =>
          setSearchText((prev) => ({
            ...prev,
            [dataIndex]: selectedKeys[0],
          }))
        }
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() =>
            setSearchText((prev) => ({
              ...prev,
              [dataIndex]: selectedKeys[0],
            }))
          }
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Search
        </Button>
        <Button
          onClick={() =>
            clearFilters && handleReset(clearFilters, dataIndex, setSearchText)
          }
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            close()
          }}
        >
          close
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered: boolean) => (
    <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
  ),
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes((value as string).toLowerCase()),
  onFilterDropdownOpenChange: (visible) => {
    if (visible) {
      setTimeout(() => searchInput.current?.select(), 100)
    }
  },
  render: (text) =>
    searchText[dataIndex] ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText[dataIndex]]}
        autoEscape
        textToHighlight={text ? text.toString() : ''}
      />
    ) : (
      text
    ),
})
